import {saveLocalData, removeLocalData} from '@/lib/base/localData';
import authService from '@/services/auth';
import userService from '@/services/user';
import store from '@/store/index.js';
import {getRoleData, getRolePermission} from '@/lib/base/roleMapping.js';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    userData: {},
    isLogin: false,
    verifyOptData: {},
    userStatistics: {},
  };
};
const state = initialState();
const getters = {
  userData(state) {
    return state.userData;
  },
  currentRole() {
    return getRoleData(state.userData?.roleId) || {};
  },
  currentPermission() {
    return getRolePermission(state.userData?.roleId);
  },
  hasMobile() {
    return !!state?.userData?.mobile;
  },
};

const actions = {
  async login({commit}, {identificationNo, password}) {
    const loginData = await authService.login(identificationNo, password);
    commit('setJwt', `Bearer ${loginData.data}`);
    return loginData;
  },
  async getMe({commit}) {
    const user = await userService.getMe();
    store.dispatch('agency/getCurrentAgency', user.agencyId);
    commit('setLogin', user);
  },
  logout({commit}) {
    removeLocalData('jwt');
    removeLocalData('examJwt');
    removeLocalData('user');
    commit('resetState');
    store.commit('exam/setCurrentExams', []);
    store.commit('exam/setCurrentExam', null);
    store.commit('popupRecord/clearRecords', null);
    //return authService.logout(); // Waiting for logout API
  },
  changePassword(_, {oldPassword, newPassword}) {
    return authService.changePassword({oldPassword, newPassword});
  },
  resetPassword(_, {password, verificationId, verificationCode}) {
    return authService.resetPassword({
      password,
      verificationId,
      verificationCode,
    });
  },
  sendResetPasswordOtp(_, {internationalPhoneNumber}) {
    return authService.sendResetPasswordOtp({internationalPhoneNumber});
  },
  validateResetPasswordOtp({commit}, verifyOptData) {
    commit('setOpt', verifyOptData);
    return authService.validateResetPasswordOtp(verifyOptData);
  },
  sendSignupOpt(_, {internationalPhoneNumber}) {
    return authService.sendSignupOpt({
      internationalPhoneNumber,
    });
  },
  validateSignupOpt({commit}, verifyOptData) {
    commit('setOpt', verifyOptData);
    return authService.validateSignupOpt(verifyOptData);
  },
  activateByCode(_, code) {
    return authService.activateByCode(code);
  },
  async getUserStatistics({commit}) {
    const res = await authService.getUserStatistics();
    commit('setUserStatistics', res);
  },
};
const mutations = {
  setLogin(state, user) {
    saveLocalData('user', JSON.stringify(user));
    state.userData = user;
    state.isLogin = true;
  },
  setJwt(state, jwt) {
    saveLocalData('jwt', jwt);
  },
  setOpt(state, verifyOptData) {
    state.verifyOptData = verifyOptData;
  },
  setUserStatistics(state, value) {
    state.userStatistics = value;
  },
  resetState(state) {
    const _state = initialState();
    Object.assign(state, _state);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
